import { render } from "./SelectInput2.vue?vue&type=template&id=20857922&scoped=true"
import script from "./SelectInput2.vue?vue&type=script&lang=js"
export * from "./SelectInput2.vue?vue&type=script&lang=js"

import "./SelectInput2.vue?vue&type=style&index=0&id=20857922&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20857922"]])

export default __exports__